/**
 *  Filename ....: case-status.component.ts
 *  Created by ..: ianday
 *  on Date .....: 3/6/24
 **/
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';

import { DataRecord } from "../../../requests/commands/req-status/req-status.component";
import { CasesService } from "../../../../services/cases.service";
import { DwUtils } from "../../../../components/utils/dw-utils";
import { Settings } from "../../../../services/settings";
import { Notes } from "../../../../models/note";
import { Case } from "../../../../models/case";
import { CaseStatus } from "../../../../models/case-status";
import { TransactionHistoryService } from "../../../../services/transactionhistory.service";
import { NoteService } from "../../../../services/note.service";
import { RecloseDialogComponent } from 'src/app/components/reclose-dialog/reclose-dialog.component';

@Component({
	selector: 'app-case-status',
	templateUrl: './case-status.component.html',
	styleUrls: ['./case-status.component.css']
})

export class CaseStatusComponent implements OnInit {

	public _caseStatusList: any;
	public _case: Case;
	public strErr: string = '';

	public enableSubmit: boolean = false;
	public selectedStatusId: any = 0;
	public selectedStatusDesc: string = '';
	public statusComment: string = '';
	public statusDesc: string = '';
	public records: any;

	displayRecloseDlg = false;

	@Output() cancelClicked: EventEmitter<any> = new EventEmitter<any>();
	@Output() submitClicked: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('reclosedlg', { static: true }) reclosedlg: RecloseDialogComponent;

	@Input() set case(val: any) {
		this._case = val;
	}
	public get case(): Case {
		return this._case;
	}

	@Input() set caseStatusList(val: Array<CaseStatus>) {

		if (val === undefined)
			return;

		this.records = [];
		this._caseStatusList = new Array();

		for (const rec of val) {

			// skip these since they have their own workflow...
			if (rec.shortDescription === 'Open') {
				continue;
			}
			this.records.push(rec);
			this._caseStatusList.push(new DataRecord(rec.id, rec.shortDescription));
		}
	}
	public get caseStatusList(): any {
		return this._caseStatusList;
	}
	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		this.strErr = '';
	}

	constructor(public casesService: CasesService, public noteService: NoteService,
		public txService: TransactionHistoryService) {
	}

	ngOnInit() {

	}
	public doInitialize(): void {
		this.selectedStatusId = 0;
		this.selectedStatusDesc = '';
		this.statusComment = '';
		this.statusDesc = '';
		this.strErr = '';

		this.enableSubmit = false;
	}

	doPreSubmitActions() {
		if (this.selectedStatusId === 0) {
			this.strErr = 'Error: Please select a status value';
			DwUtils.setFocus('statusId');
			return;
		}
		if (this.case.clericalOpen === 1) {
			this.openRecloseDialog();
			this.reclosedlg.showCaseRecloseHandler(this.case);
		} else {
			this.continueSubmitProcess(null);
		}
	}

	public continueSubmitProcess(payload: any): void {

		this.strErr = '';
		/*** Submission order:
		 * 1. update the service request record (updating record_status, request_status_id, status_reason_id
		 * 2. If there are any comments, move them to the notes section - along with the status selected.
		 * ***/


		/*** set up values ***/
		const requestStat = this.records.find(s => s.id === Number(this.selectedStatusId));
		this.statusDesc = requestStat.shortDescription;

		this.case.caseStatus = this.statusDesc;
		if (payload) {
			this.case.newDateOpened = payload.dateSubmitted;
			this.case.newDateClosed = payload.dateClosed;
			this.case.suppressEmailFlag = payload.supressEmails;
		}

		/*** issue update ... ***/
		this.casesService.updateStatusForCaseRecord(this.case.id, this.statusDesc, this.case).subscribe(
			(result) => {
					this.case.dateOpened = result['dateOpened'];
					this.case.dateClosed = result['dateClosed'];
					this.case.clericalOpen = result['clericalOpen'];

				/** create a transaction history record **/

				this.txService.createTransactionHistory('Cases', this.case.id, 'Update',
					'Change Status: ' + this.statusDesc);

				// all good. If there are comments, make a note of them.

				if ((this.statusComment.length > 0) || (this.selectedStatusId > 0)) {

					const note = this.createNoteRecord(this.selectedStatusId, this.statusComment, this.statusDesc);

					this.noteService.createNote(note).subscribe(
						(result1) => {
							// yay all good - throw the 'update success' event.
							this.emitSubmitEvent();
							return;
						},
						(error) => {
							Settings.getInstance().handleError(error, 'Adding a new note');
						});
				}
				else {
					// throw the 'update success' event.
					this.emitSubmitEvent();
				}
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Updating service request.')
			});
	}
	public onCancelClicked(): void {
		this.cancelClicked.emit();
	}
	public emitSubmitEvent(): void {
		this.submitClicked.emit(this.case);
	}
	public onSelectStatus(val: any): void {

		this.enableSubmit = true;
		this.selectedStatusDesc = this.records.find(s => s.id === val).description;

	}
	public createNoteRecord(statusId: number, comments: string, statusDesc: string): Notes {

		let note: Notes = new Notes();

		note.foreignKeyId = this.case.id;
		note.foreignKeyTable = 'Cases';
		note.noteCategory = 'General';
		note.dateAdded = DwUtils.returnCurrentDateTime();
		note.userUid = Settings.getInstance().loggedInUser.username;
		note.userFullName = Settings.getInstance().loggedInUser.name;

		if (statusId > 0) {
			note.commentText = 'Status: [ ' + statusDesc + ' ]';
		}

		if (comments.length > 0) {
			note.commentText += comments;
		}
		return note;
	}

	openRecloseDialog() {
		this.displayRecloseDlg = true;
	}
	submitFromRecloseDialog(event) {
		this.displayRecloseDlg = false;
		this.continueSubmitProcess(event);
	}
	cancelFromRecloseDialog(event) {
		this.displayRecloseDlg = false;
	}
}


